import { getCurrentUser } from './current_user.js?v=20260722a';

let stopRuntime = null;
export function startUserPresence() {
  if (stopRuntime) return;
  // Per document, not localStorage/sessionStorage: duplicated tabs are separate windows.
  const id = crypto.randomUUID();
  let pending = false;
  let closed = false;
  const body = close => JSON.stringify({ id, close, visible: document.visibilityState === 'visible' });
  const report = async () => {
    if (pending || closed || !getCurrentUser()) return;
    pending = true;
    try {
      await fetch('/api/auth/presence', { method: 'POST', headers: { 'content-type': 'application/json' }, body: body(false) });
    } catch { /* Offline windows expire server-side; retry on the next heartbeat. */ }
    finally { pending = false; }
  };
  const retire = () => {
    closed = true;
    navigator.sendBeacon('/api/auth/presence', new Blob([body(true)], { type: 'application/json' }));
  };
  const resume = () => { closed = false; void report(); };
  const timer = setInterval(report, 30000);
  window.addEventListener('pagehide', retire);
  window.addEventListener('pageshow', resume);
  document.addEventListener('visibilitychange', report);
  void report();
  stopRuntime = () => {
    retire();
    clearInterval(timer);
    window.removeEventListener('pagehide', retire);
    window.removeEventListener('pageshow', resume);
    document.removeEventListener('visibilitychange', report);
    stopRuntime = null;
  };
}
export function stopUserPresence() { stopRuntime?.(); }
